import type { AvaApiRESTBaseQueryArgs } from '@src/providers/UserContextProvider/avaApiRESTBaseQuery';
import { baseRestApi, sendToastOnQueryFulfilled } from '@src/utils/rtkQuery';
import { abbreviateId } from '@talos/kyoko';

const activateDealApiEndpoints = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    activateDeal: builder.mutation<unknown, { dealId: string }>({
      query: ({ dealId }) =>
        ({
          method: 'POST',
          url: `/contracts/deals/${dealId}/activate`,
        }) satisfies AvaApiRESTBaseQueryArgs,
      onQueryStarted: sendToastOnQueryFulfilled({
        successMessage: ({ dealId }) => `Deal ${abbreviateId(dealId)} activated.`,
        errorMessage: 'Could not activate deal',
      }),
    }),
  }),
});

export const { useActivateDealMutation } = activateDealApiEndpoints;
